<template>
    <div class="m_pad max-w-screen-xl mx-auto" role="main">
        <h1 class="mx-auto py-4 text-left text-4xl font-bold">{{ $t('Home.FilingApproach.Heading') }}</h1>
        <p class="text-xl py-2 mx-auto text-left" id="filing-approach-info-block">{{ $t('Home.FilingApproach.Intro') }}</p>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="online-approach-button"
                :aria-label="$t(`Home.FilingApproach.OnlineApproachButton.Name`) + ' ' + $t(`Home.FilingApproach.OnlineApproachButton.Description`)"
                @click="filingApproachSelection(FilingApproach.Online)">
                <p class="button-header">{{ $t(`Home.FilingApproach.OnlineApproachButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingApproach.OnlineApproachButton.Description`) }}</p>
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="in-person-approach-button"
                :aria-label="$t(`Home.FilingApproach.InPersonApproachButton.Name`) + ' ' + $t(`Home.FilingApproach.InPersonApproachButton.Description`)"
                @click="filingApproachSelection(FilingApproach.InPerson)">
                <p class="button-header">{{ $t(`Home.FilingApproach.InPersonApproachButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingApproach.InPersonApproachButton.Description`) }}</p>
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="mail-in-approach-button"
                :aria-label="$t(`Home.FilingApproach.MailInApproachButton.Name`) + ' ' + $t(`Home.FilingApproach.MailInApproachButton.Description`)"
                @click="filingApproachSelection(FilingApproach.MailIn)">
                <p class="button-header">{{ $t(`Home.FilingApproach.MailInApproachButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingApproach.MailInApproachButton.Description`) }}</p>
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="third-party-approach-button"
                :aria-label="$t(`Home.FilingApproach.ThirdPartyApproachButton.Name`) + ' ' + $t(`Home.FilingApproach.ThirdPartyApproachButton.Description`)"
                @click="filingApproachSelection(FilingApproach.ThirdParty)">
                <p class="button-header">{{ $t(`Home.FilingApproach.ThirdPartyApproachButton.Name`) }}</p>
                <p class="button-info">{{ $t(`Home.FilingApproach.ThirdPartyApproachButton.Description`) }}</p>
            </button>    
        </div>          
        <div class="mx-auto py-2 main-controls">
            <NavigationControls 
                :showBackButton="true"
                :showHelpButton="true" 
                @openHelp="openHelp()" 
                @previousPage="previousPage()"/>
            <Help 
                :page="0" 
                v-show="isHelpVisible" 
                @closeHelp="closeHelp()"/>
        </div>          
    </div>
</template>

<script>

import { AppHasData, FilingApproach } from '../../assets/constants.js'
import NavigationControls from '../common/NavigationControls.vue'
import Help from '../common/Help.vue'
export default {
    name: 'FilingApproach',
    components: {
        NavigationControls,
        Help
    },
    data: () => ({
        FilingApproach: FilingApproach,
        fbnFiling: {},
        isHelpVisible: false
    }),
    methods: {
        filingApproachSelection (approach) {
            this.fbnFiling = this.$store.getters.getFbnFiling
            this.fbnFiling.approach = approach
            this.$store.dispatch('setFbnFiling', this.fbnFiling)
            this.$store.dispatch('setFilingApproach', approach)
            this.$store.dispatch('setSubheader', approach)
            this.$router.push('fbnfilingworkflow')
        },
        openHelp () {
            this.isHelpVisible = true
        },
        closeHelp () {
            this.isHelpVisible = false
        },
        previousPage () {
            this.$router.push('/')
        }
    },
    beforeMount () {
        AppHasData(this.$store.getters.getAppHasData, this)
        window.scrollTo(0,0)
    }
}

</script>

<style scoped>

    .max-w-100 {
        width: 100%;
    }

    p {
        line-height: 1.65em !important;
    }

</style>
